import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'

import { SiteMetaData } from '~/types/common.types'

import { useLogo } from '~/hooks/useLogo'

import { SEO } from '~/components/Layout'

const Head: React.VFC<SEO> = ({ title, description, siteUrl, image }) => {
  const {
    site: { siteMetadata },
  } = useStaticQuery<{ site: SiteMetaData }>(query)

  const { coverPublicURL } = useLogo()
  const ogImage = image ?? coverPublicURL

  const ogTitle = title ? `${title} | ${siteMetadata.title}` : siteMetadata.title

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="initial-scale=1.0, user-scalable=no, maximum-scale=1, minimum-scale=1.0, width=device-width"
      />
      <meta httpEquiv="Content-Type" content="text/html;charset=UTF-8" />

      <title>{ogTitle}</title>
      <meta property="og:title" content={ogTitle} />
      <meta name="description" content={description || siteMetadata.description} />
      <meta property="og:description" content={description || siteMetadata.description} />
      <meta
        name="keywords"
        content="1000peach, 블로그, 기술 블로그, 포트폴리오, it, devlog, 웹, 프론트, 퍼블리싱, 주니어, 개발자, react, nextjs, gatsby, javascript, typescript"
      />
      <meta property="og:image" content={ogImage} />

      <meta property="og:site_name" content={siteMetadata.title} />
      <meta property="og:type" content="website" />
      {/* <meta property="og:url" content={siteUrl || siteMetadata.siteUrl} /> */}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={description || siteMetadata.description} />
      <meta name="twitter:image" content={ogImage} />

      {/* 웹 마스터 메타 태그 */}
      <meta name="google-site-verification" content="fYM1sUrnwriVRTftqNa3J-WcKbE-bJWcd2hZQyZEChM" />
      <meta name="naver-site-verification" content="fd59f2ab174fab32a9ab823dd7a02d0397bfef20" />

      <html lang="ko" />
      {/* <meta name="twitter:site" content="@1000peach" />
      <meta name="twitter:creator" content="@1000peach" /> */}
    </Helmet>
  )
}

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        title
        author
        description
        siteUrl
      }
    }
  }
`

export default Head
